import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  id: "myTab",
  role: "tablist"
}
const _hoisted_5 = {
  class: "nav-item",
  role: "tablist"
}
const _hoisted_6 = ["aria-selected"]
const _hoisted_7 = {
  class: "nav-item",
  role: "tablist"
}
const _hoisted_8 = ["aria-selected"]
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "fw-semibold mb-8" }
const _hoisted_11 = { class: "fw-bold" }
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = {
  key: 0,
  class: "row justify-content-left p-3"
}
const _hoisted_15 = { class: "card mb-25 ml-1 border-0 rounded-0 bg-white letter-spacing col-auto" }
const _hoisted_16 = { class: "card-body shift-card-body" }
const _hoisted_17 = { class: "align-items-center" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "product-details-content" }
const _hoisted_20 = { class: "info ps-0 list-unstyled d-inline-block" }
const _hoisted_21 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_22 = { class: "overView-value" }
const _hoisted_23 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_24 = { class: "overView-value" }
const _hoisted_25 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_26 = { class: "overView-value" }
const _hoisted_27 = { class: "card mb-25 ml-1 border-0 rounded-0 bg-white letter-spacing col-auto" }
const _hoisted_28 = { class: "card-body shift-card-body" }
const _hoisted_29 = { class: "align-items-center" }
const _hoisted_30 = { class: "" }
const _hoisted_31 = { class: "product-details-content" }
const _hoisted_32 = { class: "info ps-0 list-unstyled d-inline-block" }
const _hoisted_33 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_34 = { class: "overView-value" }
const _hoisted_35 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_36 = { class: "overView-value" }
const _hoisted_37 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_38 = { class: "overView-value" }
const _hoisted_39 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_40 = { class: "overView-value" }
const _hoisted_41 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_42 = { class: "overView-value" }
const _hoisted_43 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_44 = { class: "overView-value" }
const _hoisted_45 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VersionCountColumnGraph = _resolveComponent("VersionCountColumnGraph")!
  const _component_SelectionModal = _resolveComponent("SelectionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("button", {
                class: _normalizeClass(['nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100', { active: (_ctx.selectedVersionType=='latest')?true:false }]),
                "aria-selected": (_ctx.selectedVersionType=='latest')?true:false,
                role: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectVersionType('latest')))
              }, " Aktuální počet instalací ", 10, _hoisted_6)
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("button", {
                class: _normalizeClass(['nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100', { active: (_ctx.selectedVersionType=='overview')?true:false }]),
                "aria-selected": (_ctx.selectedVersionType=='overview')?true:false,
                role: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectVersionType('overview')))
              }, " Historicky nainstalované verze ", 10, _hoisted_8)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h4", _hoisted_10, [
            _cache[2] || (_cache[2] = _createTextVNode(" Produkt: ", -1)),
            _createElementVNode("span", _hoisted_11, _toDisplayString((_ctx.route.params.product == "all")?"Všechny":_ctx.route.params.product), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[12] || (_cache[12] = _createElementVNode("ul", {
                class: "nav nav-tabs bg-white border-0 rounded-0 align-text-bottom",
                id: "myTab",
                role: "tablist"
              }, null, -1)),
              (_ctx.detailData.productOverview != undefined)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("ul", _hoisted_20, [
                                _createElementVNode("li", _hoisted_21, [
                                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Aktuální verze: ", -1)),
                                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.detailData.productOverview.currentVersion), 1)
                                ]),
                                _createElementVNode("li", _hoisted_23, [
                                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Počet instalací aktuální verze: ", -1)),
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.detailData.productOverview.currentVersionInstallationCount), 1)
                                ]),
                                _createElementVNode("li", _hoisted_25, [
                                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "První datum instalace verze: ", -1)),
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.detailData.productOverview.currentVersionDate), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("ul", _hoisted_32, [
                                _createElementVNode("li", _hoisted_33, [
                                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Celkový počet unikátních instalací: ", -1)),
                                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.detailData.productOverview.totalInstallationCount), 1)
                                ]),
                                _createElementVNode("li", _hoisted_35, [
                                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Celkový počet FULL licencí: ", -1)),
                                  _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.detailData.productOverview.licenseFullCount), 1)
                                ]),
                                _createElementVNode("li", _hoisted_37, [
                                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Celkový počet DEMO licencí: ", -1)),
                                  _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.detailData.productOverview.licenseDemoCount), 1)
                                ]),
                                _createElementVNode("li", _hoisted_39, [
                                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Celkový počet TRIAL licencí: ", -1)),
                                  _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.detailData.productOverview.licenseTrialCount), 1)
                                ]),
                                _createElementVNode("li", _hoisted_41, [
                                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Celkový počet verzí: ", -1)),
                                  _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.detailData.productOverview.totalVersionCount), 1)
                                ]),
                                _createElementVNode("li", _hoisted_43, [
                                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Nejvíce instalovaná verze: ", -1)),
                                  _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.detailData.productOverview.mostInstalledVersion), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_VersionCountColumnGraph, {
              graphData: _ctx.preparedGraphData,
              graphLabel: _ctx.prepareGraphLabel
            }, null, 8, ["graphData", "graphLabel"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_SelectionModal, { ref: "selectionRef" }, null, 512)
  ], 64))
}